import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const ContractsTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  {
    title: 'Name',
    align: 'start',
    key: 'name',
    sortable: false,
    placeholder: 'Contract name',
  },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
